import { debounce } from 'lodash';
import tippy from 'tippy.js/headless';
import domReady from '../helpers/dom-ready';

class WC {
  static init(...parameters) {
    return new WC(...parameters);
  }

  constructor() {
    this.setupCategoriesTabMenu();
  }

  setupCategoriesTabMenu() {
    this.wrapper = document.querySelector('.product-archive-wrapper');
    if (this.wrapper) {
      this.tabMenuWrapper = this.wrapper.querySelector('.tab-menu-wrapper');
      this.tabMenu = this.wrapper.querySelector('.tab-menu');

      if (this.tabMenu) {
        this.tabMenuScrollWidth = this.tabMenu.scrollWidth;

        this.toggleDropdown();
        window.addEventListener('resize', debounce(() => {
          this.toggleDropdown();
        }), 300);
      }
    }
  }

  toggleDropdown() {
    const { offsetWidth } = this.tabMenuWrapper;

    if (offsetWidth <= this.tabMenuScrollWidth) {
      this.tabMenuWrapper.classList.add('-hidden');
      this.tabMenuWrapper.setAttribute('aria-hidden', 'true');

      if (!this.dropdownMenuWrapper) {
        this.addDropdownMenu();
      } else {
        this.dropdownMenuWrapper.classList.remove('-hidden');
      }
    } else {
      if (this.dropdownMenuWrapper) {
        this.dropdownMenuWrapper.classList.add('-hidden');
      }

      this.tabMenuWrapper.classList.remove('-hidden');
      this.tabMenuWrapper.setAttribute('aria-hidden', 'false');
    }
  }

  addDropdownMenu() {
    this.dropdownMenuWrapper = document.createElement('div');
    this.dropdownMenuWrapper.classList.add('dropdown-menu-wrapper');
    this.dropdownMenuToggle = document.createElement('button');
    this.dropdownMenuToggle.classList.add('dropdown-menu-toggle');
    this.dropdownMenu = this.tabMenu.cloneNode(true);
    this.dropdownMenu.classList.remove('tab-menu');
    this.dropdownMenu.classList.add('dropdown');

    this.currentPageLink = this.dropdownMenu.querySelector('.-current');
    if (this.currentPageLink) {
      this.currentPageLinkLabel = this.currentPageLink.querySelector('.label');
      this.dropdownMenuToggle.innerHTML = this.currentPageLinkLabel.innerHTML;
    }

    this.dropdownMenuWrapper.appendChild(this.dropdownMenuToggle);
    this.dropdownMenuWrapper.appendChild(this.dropdownMenu);
    this.tabMenuWrapper.after(this.dropdownMenuWrapper);

    if (!this.tippyInstance) {
      this.setUpTippy();
    }
  }

  setUpTippy() {
    this.tippyInstance = tippy(this.dropdownMenuToggle, {
      content: this.dropdownMenu,
      offset: [0, 0],
      allowHTML: true,
      trigger: 'click',
      appendTo: this.dropdownMenuWrapper,
      interactive: 'true',
      placement: 'bottom-start',
      plugins: [{
        name: 'hideOnPopperBlur',
        defaultValue: true,
        fn(instance) {
          return {
            onCreate() {
              instance.popper.addEventListener('focusout', (event) => {
                if (
                  instance.props.hideOnPopperBlur
                      && event.relatedTarget
                      && !instance.popper.contains(event.relatedTarget)
                ) {
                  instance.hide();
                }
              });
            },
          };
        },
      }],
      popperOptions: {
        strategy: 'fixed',
        modifiers: [
          {
            name: 'preventOverflow',
            options: {
              padding: 0,
            },
          },
        ],
      },
      render(instance) {
        const popper = document.createElement('div');
        popper.appendChild(instance.props.content);
        return { popper };
      },
    });
  }
}

domReady(() => {
  WC.init();
});
